// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Xixa","head":"Table_head__3ybAA","col":"Table_col__3UKsw"};